import type { ReactNode } from 'react';

// The prototype's `tg` — a word in a tone, never a tone alone (§9). The tones
// are the prototype's own map; the registration screens use five of them.
// request-a-stay adds the three its care chips and card states use: meds,
// apart and due.
export type TagTone = 'ok' | 'neutral' | 'wait' | 'todo' | 'bad' | 'meds' | 'apart' | 'due' | 'warn';

export function Tag({ tone, glyph, children }: { tone: TagTone; glyph?: ReactNode; children: ReactNode }) {
  return (
    <span className={'tg ' + tone + (glyph ? '' : ' noglyph')}>
      {glyph}
      {children}
    </span>
  );
}
